import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewEsqueceuSenha from "../views/ViewEsqueceuSenha";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* garante altura total */
  background: linear-gradient(135deg, #003644, #0096c7);
`;



const EsqueceuSenha: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerComponente>
      <ViewAppBar />
     
        <ViewEsqueceuSenha />
      
      <ViewFooter />
    </ContainerComponente>
  </>
);

export default EsqueceuSenha;
